import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _SummaryElement;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
export let SummaryElementType = /*#__PURE__*/function (SummaryElementType) {
  SummaryElementType["OPEN_PAREN"] = "OPEN_PAREN";
  SummaryElementType["CLOSE_PAREN"] = "CLOSE_PAREN";
  SummaryElementType["LIST_BULLET"] = "LIST_BULLET";
  SummaryElementType["LIST_BULLET_ELSE"] = "LIST_BULLET_ELSE";
  SummaryElementType["AND"] = "AND";
  SummaryElementType["OR"] = "OR";
  SummaryElementType["LEAF"] = "LEAF";
  SummaryElementType["TEXT"] = "TEXT";
  SummaryElementType["OPERATOR"] = "OPERATOR";
  return SummaryElementType;
}({});
export class SummaryElementSet {
  constructor(depth) {
    _defineProperty(this, "elements", []);
    _defineProperty(this, "_operatorNode", void 0);
    _defineProperty(this, "_depth", void 0);
    this._depth = depth;
  }
  get depth() {
    return this._depth;
  }
  // Some custom handlers need to specifcally set the depth of the row
  set depth(value) {
    this._depth = value;
  }
  addElement(element) {
    this.elements.push(element);
  }
  get operatorNode() {
    return this._operatorNode;
  }
  set operatorNode(value) {
    this._operatorNode = value;
  }
}
export class SummaryElement {
  constructor(type, value, options) {
    _defineProperty(this, "_value", void 0);
    _defineProperty(this, "_expSummaryElementOptions", void 0);
    this.type = type;
    this._value = value;
    this._expSummaryElementOptions = options;
  }
  get value() {
    switch (this.type) {
      case SummaryElementType.CLOSE_PAREN:
      case SummaryElementType.OPEN_PAREN:
      case SummaryElementType.LIST_BULLET:
      case SummaryElementType.AND:
      case SummaryElementType.OR:
      case SummaryElementType.TEXT:
        return this._value;
      case SummaryElementType.LIST_BULLET_ELSE:
        return `${this._value} ${AbReactResources.expression_editor_action_else_prefix()}`;
      case SummaryElementType.LEAF:
      case SummaryElementType.OPERATOR:
        if (!this._value) {
          throw new Error(`Missing value for ${SummaryElementType.LEAF}`);
        }
        return this._value;
      default:
        throw new Error(`Unsupported SummaryElementType: ${this.type}`);
    }
  }
  get expSummaryElementOptions() {
    return this._expSummaryElementOptions;
  }
}
_SummaryElement = SummaryElement;
_defineProperty(SummaryElement, "AND", new _SummaryElement(SummaryElementType.AND, "AND"));
_defineProperty(SummaryElement, "OR", new _SummaryElement(SummaryElementType.OR, "OR"));
_defineProperty(SummaryElement, "OPEN_PAREN", new _SummaryElement(SummaryElementType.OPEN_PAREN, "("));
_defineProperty(SummaryElement, "CLOSE_PAREN", new _SummaryElement(SummaryElementType.CLOSE_PAREN, ")"));
_defineProperty(SummaryElement, "LIST_BULLET", new _SummaryElement(SummaryElementType.LIST_BULLET, "-"));
_defineProperty(SummaryElement, "LIST_BULLET_ELSE", new _SummaryElement(SummaryElementType.LIST_BULLET_ELSE, "-"));
//# sourceMappingURL=ExpressionSummaryElement.js.map
